<dx-select-box [dataSource]="dataSource"
               [value]="teamId"
               [showClearButton]="showClearButton"
               (onValueChanged)="onTeamIdChanged($event)"
               valueExpr="teamId"
               displayExpr="name"></dx-select-box>
